import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Utils
import { getFileOpenUrl, getFileRawUrl } from 'utils/google-drive-utils';

export default class CallDetails extends React.Component {
  static propTypes = {
    call: PropTypes.object.isRequired
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.call.id === nextProps.call.id) return false;
  }

  render() {
    const { call } = this.props;

    return (
      <li className="triage-option-header call-recording">
        { !_.isEmpty(call.recording) &&
          <audio controls>
            <source src={getFileRawUrl(call.recording.fileId)} type={call.recording.mimetype} />
            <a href={getFileOpenUrl(call.recording.fileId)} type="audio/mpeg">
              View in Drive (your browser does not support the audio element)
            </a>
          </audio>
        }
      </li>
    );
  }
}
